
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Busonrentinhadapsar() {



    const cardData =
    {
        keyword: 'Bus on Rent in Hadapsar',
        heading: 'Amruta Travels: Bus on Rent in Hadapsar',
        headingDescription: 'Amruta Travels offers Bus on Rent in Hadapsar, providing reliable and comfortable transportation solutions for various occasions. Whether you are organizing a corporate event, school trip, family function, or group tour, our well-maintained buses ensure a smooth and enjoyable journey. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your travel in and around Hadapsar simple and stress-free. Book your bus with Amruta Travels and experience a journey of comfort and convenience!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



    "services": [
    {
      "name": "Mini Bus on Rent in Magarpatta City-Hadapsar",
      "description": "Amruta Travels offers mini buses on rent in Magarpatta City, Hadapsar for family outings, corporate events, or small group trips. Our fleet includes comfortable and well-maintained mini buses with experienced drivers for a smooth and enjoyable journey."
    },
    {
      "name": "Urbania Bus on Rent in Hadapsar",
      "description": "Experience luxury and comfort with our Urbania bus on rent in Hadapsar. Ideal for corporate events, team outings, or special occasions, the Urbania bus offers spacious seating, modern amenities, and a smooth ride to your destination."
    },
    {
      "name": "Corporate Bus Hire in Hadapsar Pune",
      "description": "Amruta Travels offers corporate bus hire services in Hadapsar, Pune for business trips, corporate events, and team outings. Our fleet of AC and non-AC buses ensures a comfortable and professional experience for your employees and clients."
    },
    {
      "name": "14 17 25 32 Seater on Rent in Hadapsar Magarpatta",
      "description": "Looking for a 14, 17, 25, or 32-seater bus for your trip in Hadapsar Magarpatta? Amruta Travels offers flexible bus rental options, perfect for family gatherings, school trips, or corporate events. Enjoy a comfortable ride with our well-maintained buses."
    },
    {
      "name": "35 40 45 50 Seater Bus Hire in Hadapsar",
      "description": "For large groups, Amruta Travels provides 35, 40, 45, and 50-seater buses for hire in Hadapsar. Whether you're planning a group outing, a wedding, or a corporate event, we offer spacious and comfortable buses for a smooth travel experience."
    },
    {
      "name": "Mini Bus on Rent in Hadapsar",
      "description": "Rent a mini bus in Hadapsar with Amruta Travels for small to medium-sized groups. Perfect for day trips, school excursions, or family get-togethers, our mini buses come with comfortable seating and ample luggage space."
    },
    {
      "name": "Bus for Wedding Near Me Hadapsar",
      "description": "Looking for a bus for your wedding in Hadapsar? Amruta Travels offers wedding bus hire services, providing large and comfortable buses to transport guests to and from wedding venues, ensuring punctuality and convenience for your special day."
    },
    {
      "name": "Bus Rental for Corporate Events in Hadapsar",
      "description": "Plan your next corporate event in Hadapsar with Amruta Travels’ bus rental services. Whether it’s a seminar, meeting, or team outing, our buses ensure your employees travel in comfort, arriving on time and ready for the event."
    },
    {
      "name": "Hire AC Luxury Bus on Rent in Magarpatta City",
      "description": "Rent an AC luxury bus in Magarpatta City, Hadapsar for a premium travel experience. Ideal for corporate events, VIP guests, or special occasions, our luxury buses offer top-notch amenities for a comfortable and elegant ride."
    },
    {
      "name": "Tempo Traveller on Rent in Hadapsar",
      "description": "Travel comfortably in a Tempo Traveller from Hadapsar for your next group outing, family trip, or corporate event. Amruta Travels offers well-maintained, air-conditioned vehicles that ensure a smooth and enjoyable journey."
    },
    {
      "name": "Mini Bus on Rent in Magarpatta Hadapsar",
      "description": "Amruta Travels offers mini buses on rent in Magarpatta Hadapsar for small to medium-sized groups. Whether you’re planning a day trip or corporate outing, our mini buses provide a comfortable and affordable option for your group travel needs."
    },
    {
      "name": "Bus on Rent in Magar Magarpatta City",
      "description": "Amruta Travels offers reliable and comfortable bus rental services in Magarpatta City, Hadapsar. Whether for group outings, picnics, or corporate events, we provide well-maintained buses with professional drivers for a safe and enjoyable trip."
    },
    {
      "name": "Bus Hire for Corporate Company in Pune",
      "description": "Rent a bus for your corporate company’s travel needs in Pune with Amruta Travels. Our buses are perfect for team-building activities, corporate picnics, client meetings, and more. We offer both AC and non-AC options for a comfortable ride."
    },
    {
      "name": "AC and Non-AC Monthly Bus Rental Services",
      "description": "Amruta Travels offers monthly bus rental services in both AC and non-AC options for regular corporate transportation, staff commute, or educational institution requirements. Book a monthly rental for hassle-free travel at affordable rates."
    }
  ],
  "tableData": [
    ["Mini Bus on Rent in Magarpatta City-Hadapsar", "Urbania Bus on Rent in Hadapsar"],
    ["Corporate Bus Hire in Hadapsar Pune", "14 17 25 32 Seater on Rent in Hadapsar Magarpatta"],
    ["35 40 45 50 Seater Bus Hire in Hadapsar", "Mini Bus on Rent in Hadapsar"],
    ["Bus for Wedding Near Me Hadapsar", "Bus Rental for Corporate Events in Hadapsar"],
    ["Hire AC Luxury Bus on Rent in Magarpatta City", "Tempo Traveller on Rent in Hadapsar"],
    ["Mini Bus on Rent in Magarpatta Hadapsar", "Bus on Rent in Magar Magarpatta City"],
    ["Bus Hire for Corporate Company in Pune", "AC and Non-AC Monthly Bus Rental Services"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Convenient Bus Rental Service in Hadapsar",
    "WhyChoosedescription": "Amruta Travels provides reliable and convenient Bus on Rent in Hadapsar, Pune—ideal for local travel, outstation trips, weddings, corporate outings, and school excursions. Whether you're planning a one-day event or a multi-day journey, we offer well-maintained buses with professional service, right from the heart of Hadapsar."
  },
  {
    "WhyChooseheading": "Wide Range of Buses for All Group Sizes",
    "WhyChoosedescription": "Choose from 17, 20, 32, 35, 40, 45, and 50-seater buses depending on your group’s size and travel requirements. All our buses are spacious, clean, and equipped with air conditioning (or non-AC options), ensuring a comfortable ride for both short and long journeys."
  },
  {
    "WhyChooseheading": "Perfect for Weddings, Events, and Tours",
    "WhyChoosedescription": "Need a bus for a wedding function, family trip, corporate tour, or school picnic? Our **Bus on Rent in Hadapsar** service is perfect for every occasion. We understand the needs of group travel and provide timely service with flexible routes and schedules tailored to your event."
  },
  {
    "WhyChooseheading": "Professional and Polite Drivers with Route Expertise",
    "WhyChoosedescription": "Our experienced drivers are courteous and well-versed with Hadapsar’s roads as well as major routes to outstation destinations like Shirdi, Goa, Lonavala, Mahabaleshwar, and Mumbai. They ensure timely pickups, safe driving, and complete route coordination for a stress-free travel experience."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer budget-friendly bus rental services with clear, upfront pricing. Whether you need a few hours of transport or a full-day trip, we provide cost-effective packages without any hidden fees—so you can manage your group travel expenses with confidence."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Buses",
    "WhyChoosedescription": "All our vehicles are regularly serviced and cleaned before every trip. We prioritize hygiene and comfort, offering buses with push-back seats, large windows, and spacious interiors—making every ride a pleasant experience, even on long routes."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off from Hadapsar and Surrounding Areas",
    "WhyChoosedescription": "We provide door-to-door service with flexible pickup and drop-off options across Hadapsar and nearby areas like Magarpatta, Amanora, Kharadi, and Undri. Whether you're starting your journey from home, office, or event venue, we’ll be there on time to get your group moving."
  },
  {
    "WhyChooseheading": "Easy Booking and Prompt Customer Support",
    "WhyChoosedescription": "Booking your bus in Hadapsar is simple and fast. Use our online booking system, call our helpline, or visit our office for assistance. Our customer support team is available to help you choose the right bus, plan routes, and provide real-time updates—making the entire rental process smooth and stress-free."
  }
]





















    }

const faqData = [
  {
    question: 'How can I rent a bus in Hadapsar, Pune?',
    answer: 'Renting a bus in Hadapsar with Amruta Travels is quick and hassle-free. You can call us, book online, or visit our office. We’ll help you select the right bus based on your group size, trip type, and preferences.',
  },
  {
    question: 'What types of buses are available for rent in Hadapsar?',
    answer: 'We offer a wide range of buses including 32, 35, 40, 45, and 50-seater options. You can choose from AC, non-AC, standard, and luxury buses to suit your travel needs.',
  },
  {
    question: 'Can I rent a bus for local travel within Hadapsar?',
    answer: 'Yes, we provide buses for local travel in Hadapsar for events, school trips, corporate transport, city tours, and short-distance journeys. Flexible pickup and drop locations are available.',
  },
  {
    question: 'Are buses available for outstation trips from Hadapsar?',
    answer: 'Absolutely. We provide outstation bus services from Hadapsar to destinations like Shirdi, Mumbai, Goa, Mahabaleshwar, and more. Our experienced drivers ensure a safe and smooth journey.',
  },
  {
    question: 'How much does it cost to rent a bus in Hadapsar?',
    answer: 'The rental cost depends on the type of bus, trip duration, distance, and other requirements. Contact us with your itinerary for a customized and transparent quote.',
  },
  {
    question: 'Are your buses clean and well-maintained?',
    answer: 'Yes, all our buses are regularly maintained and sanitized before every trip to ensure safety, hygiene, and comfort for passengers.',
  },
  {
    question: 'Can I request multiple pickup points in Hadapsar or nearby areas?',
    answer: 'Yes, we provide flexible routing with multiple pickup and drop-off locations in Hadapsar and surrounding areas. Just share your schedule in advance.',
  },
  {
    question: 'Do you offer buses for corporate or factory transport in Hadapsar?',
    answer: 'Yes, we specialize in corporate and industrial staff transportation. Our services are punctual, reliable, and tailored to your organization’s requirements.',
  },
  {
    question: 'Why choose Amruta Travels for bus rental in Hadapsar?',
    answer: 'Amruta Travels offers reliable service, a modern fleet, professional drivers, and customized travel solutions. We’re known for punctuality, safety, and customer satisfaction in Hadapsar and beyond.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Pravin Shinde',
    role: 'Corporate HR, Hadapsar',
    text: 'We hired a 50-seater bus from Amruta Travels for a team-building trip from Hadapsar to Mahabaleshwar. The bus was clean, on time, and the entire journey was hassle-free. Great service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Leena Patil',
    role: 'Event Organizer, Hadapsar',
    text: 'Amruta Travels provided excellent service for our wedding guests in Hadapsar. The 40-seater AC bus was comfortable and the driver was very courteous. Will definitely book again!',
    rating: 5,
  },
];
























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent in Hadapsar",
  "image": "https://bushireinpune.com/assets/images/bus-on-rent-in-hadapsar.jpg",
  "description": "Bus rental services in Hadapsar and Magarpatta City for corporate travel, weddings, events, and staff transport. Choose from AC and non-AC buses, Tempo Travellers, Urbania, and 14 to 50 seater options. Monthly bus hire plans available for companies in Hadapsar, Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6430"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3399",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-on-rent-in-hadapsar"
  }
};




    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Bus on Rent in Hadapsar & Magarpatta | Corporate, Wedding & Monthly Hire</title>
  <meta 
    name="description" 
    content="Hire buses in Hadapsar & Magarpatta City for corporate, wedding & monthly use. AC/Non-AC 14 to 50 seater buses, Tempo Travellers & Urbania available. Ideal for events & company transport in Pune." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/44.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busonrentinhadapsar;